import React from 'react'
import DashboardStatsGrid from '../components/DashboardStatsGrid'
import InvoiceListing from '../components/InvoiceListing'
import { DataVisual } from './DataVisual'
import Leads from './Transactions'
// import TransactionChart from '../components/TransactionChart'
// import RecentOrders from '../components/RecentOrders'
// import BuyerProfilePieChart from '../components/BuyerProfilePieChart'
// import PopularProducts from '../components/PopularProducts'

export default function Dashboard() {
	return (
		<div className="flex flex-col gap-4 w-full">
			<DashboardStatsGrid />


		<Leads/>
		</div>
	)
}